export default "__VITE_ASSET__B$Ui6lDT__"